import React from "react";
import { FormattedHTMLMessage } from "react-intl";
import { Link } from "react-router-dom";

import * as routes from "../constants/routes";

const SignUpLink = () => {
  return (
    <Link to={routes.DETAILER_SIGNUP} className="buttonSignUp">
      <FormattedHTMLMessage id="SignUpLink.SignUp" />
    </Link>
  );
};

export default SignUpLink;



// WEBPACK FOOTER //
// ./src/components/SignUpLink.js